import About from "../components/About";
import WhyUs from "../components/WhyUs";
import Portfolio from "../components/Portfolio";

export default function AboutPage() {
  return (
    <div className="pt-24 sm:pt-28">
      <About />
      <WhyUs />
      <Portfolio />
    </div>
  );
}
